export const NOTE_STATUS_FILTER_OPTIONS = [
  ['unextracted', 'Hint未抽出'],
  ['extracted', 'Hint抽出済'],
  ['all', 'すべて'],
];

export const INSIGHT_STATUS_FILTER_OPTIONS = [
  ['suggested', '未処理'],
  ['accepted', 'Asset化済み'],
  ['rejected', '却下'],
  ['all', 'すべて'],
];

export const ASSET_STATUS_FILTER_OPTIONS = [
  ['active', '使用中'],
  ['pending', '保留'],
  ['draft', '下書き'],
  ['all', 'すべて'],
];

export function getStatusFilterOptions(viewMode) {
  if (viewMode === 'notes') return NOTE_STATUS_FILTER_OPTIONS;
  if (viewMode === 'insights') return INSIGHT_STATUS_FILTER_OPTIONS;
  if (viewMode === 'assets') return ASSET_STATUS_FILTER_OPTIONS;
  return [];
}

export function isStatusFilterAllowed(viewMode, status) {
  return getStatusFilterOptions(viewMode).some(([value]) => value === status);
}
